import Swiper from "swiper";

export function blockHomeHeading() {
  new Swiper(".home-heading__swiper", {
    direction: "horizontal",
    slidesPerView: 1, 
    spaceBetween: 0,
  });
}
